export const SHARED_PASSAGE = 'sharedpassage';
